import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatSortModule } from '@angular/material/sort';
import { FormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';

import { InterceptorService } from '../services/interceptor.service';
import { SharedModule } from '../shared/shared.module';
import { AdminProfileComponent } from './admin-profile/admin-profile.component';
import { ChallengeTimeComponent } from './challenge-time/challenge-time.component';
import { ConfirmTransferComponent } from './confirm-transfer/confirm-transfer.component';
import { ConfirmdisableComponent } from './confirmdisable/confirmdisable.component';
import { CreateAlliedComponent } from './create-allied/create-allied.component';
import { AgencyDialogComponent } from './agency/agency-dialog.component';
import { MadegroupformComponent } from './create-group/create-group.component';
import { DeleteFacilitatorComponent } from './delete-facilitator/delete-facilitator.component';
import { DeleteOportComponent } from './delete-oport/delete-oport.component';
import { DeleteNotificationComponent } from './deleteNotifaction/deleteNotification.component';
import { DeletecompanyComponent } from './deletecompany/deletecompany.component';
import { DetailAdvertisingComponent } from './detail-advertising/detail-advertising.component';
import { DisableFailitatorComponent } from './disable-failitator/disable-failitator.component';
import { EditAlliedComponent } from './edit-allied/edit-allied.component';
import { EditgroupComponent } from './editgroup/editgroup.component';
import { EnabledFacilitatorComponent } from './enabled-facilitator/enabled-facilitator.component';
import { EnableorganizationComponent } from './enableorganization/enableorganization.component';
import { ErrorFileComponent } from './error-file/error-file.component';
import { GeneralTimeCircleComponent } from './general-time-circle/general-time-circle.component';
import { ItemNotCreatedComponent } from './item-not-created/item-not-created.component';
import { ListCompanyComponent } from './list-companies/list-compani.component';
import { ListFacilitatorComponent } from './list-facilitators/list-facilitator.component';
import { ListGroupComponent } from './list-groups/list-group.component';
import { ListNotificationComponent } from './list-notifications/list-notification.component';
import { ListOportunitiesComponent } from './list-oportunities/list-oportunities.component';
import { LoginsuccesComponent } from './loginsucces/loginsucces.component';
import { MadegoupdialogComponent } from './madegoupdialog/madegoupdialog.component';
import { MasivechargeComponent } from './masivecharge/masivecharge.component';
import { NoMatchesComponent } from './no-matches/no-matches.component';
import { PswChangeModalComponent } from './psw-change-modal/psw-change-modal.component';
import { RecoveryComponent } from './recovery/recovery.component';
import { RessetpwdComponent } from './ressetpwd/ressetpwd.component';
import { SeeGroupDetailComponent } from './see-group-detail/see-group-detail.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { TransferAdvertisingComponent } from './transfer-advertising/transfer-advertising.component';
import { TransferFacilitatorComponent } from './transfer-facilitator/transfer-facilitator.component';
import { TypeOportunitieAdviseComponent } from './type-oportunitie-advise/type-oportunitie-advise.component';
import { ListFreeCompaniesComponent } from './list-free-companies/list-free-companies.component';
import { AlliedIdComponent } from './allied-id/allied-id.component';
import { LineaBaseImportComponent } from './linea-base-import/linea-base-import.component';

import { CreateUserAlliedComponent } from './create-user-allied/create-user-allied.component';
import { ListUserAlliedsComponent } from './list-user-allieds/list-user-allieds.component';
import { ListFreeCompaniesStandardComponent } from './list-free-companies-standard/list-free-companies-standard.component';

@NgModule({
  declarations: [
    LoginsuccesComponent,
    RecoveryComponent,
    RessetpwdComponent,
    SidebarComponent,
    CreateAlliedComponent,
    EditAlliedComponent,
    ConfirmdisableComponent,
    MadegoupdialogComponent,
    MadegroupformComponent,
    MasivechargeComponent,
    LineaBaseImportComponent,
    ListFacilitatorComponent,
    ListGroupComponent,
    EditgroupComponent,
    ListCompanyComponent,
    DeletecompanyComponent,
    ListNotificationComponent,
    DeleteNotificationComponent,
    ListOportunitiesComponent,
    DeleteOportComponent,
    DeleteFacilitatorComponent,
    AdminProfileComponent,
    DisableFailitatorComponent,
    ErrorFileComponent,
    NoMatchesComponent,
    EnableorganizationComponent,
    TransferFacilitatorComponent,
    ConfirmTransferComponent,
    TransferAdvertisingComponent,
    PswChangeModalComponent,
    ItemNotCreatedComponent,

    TypeOportunitieAdviseComponent,
    DetailAdvertisingComponent,
    SeeGroupDetailComponent,
    EnabledFacilitatorComponent,
    ChallengeTimeComponent,
    GeneralTimeCircleComponent,
    ListFreeCompaniesComponent,
    AlliedIdComponent,
    AgencyDialogComponent,

    CreateUserAlliedComponent,
    ListUserAlliedsComponent,

    ListFreeCompaniesStandardComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatDividerModule,
    MatSortModule,
    FormsModule,
    MatTableModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
  ],
  exports: [
    SidebarComponent,
    ListFacilitatorComponent,
    ListGroupComponent,
    ListCompanyComponent,
    DeletecompanyComponent,
    ListNotificationComponent,
    ListFreeCompaniesComponent,
    ListOportunitiesComponent,
    DeleteFacilitatorComponent,
    AdminProfileComponent,
    ErrorFileComponent,
    NoMatchesComponent,
    EnableorganizationComponent,
    DeleteNotificationComponent,
    ItemNotCreatedComponent,
    TypeOportunitieAdviseComponent,
    ChallengeTimeComponent,

    ListUserAlliedsComponent,
    ListFreeCompaniesStandardComponent,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true,
    },
  ],
})
export class ComponentsModule {}
